<script>
export default {
  name: "cn-for-privacy"
}
</script>

<template>



  <div class=WordSection1 style='layout-grid:15.6pt'>

    <p style='text-align:justify'><span lang=EN-US style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#2C3E50'>Privacy Policy</span></p>

    <p style='text-align:justify'><span lang=EN-US style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#2C3E50'>Preface</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:black'>This policy
is based on the products and products provided by Wonder Game Inc.(hereinafter
collectively referred to as &quot;Wonder Game&quot;) on the website platform (Wonder
Gamedashi.cn) and mobile terminal of it and/</span><span lang=EN-US
                                                         style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>or its
affiliates. Services (including game services and other network services
currently provided by Wonder Game on the website platform and mobile terminals
and may be provided to users in the future, collectively referred to as
&quot;products and services&quot; below).</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>This
policy will help you understand the following:</span></p>

    <p style='text-align:justify'><span lang=EN-US style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#2C3E50'>1. How we collect and use your
personal information</span></p>

    <p style='text-align:justify'><span lang=EN-US style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#2C3E50'>2. How do we use cookies and
similar technologies</span></p>

    <p style='text-align:justify'><span lang=EN-US style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#2C3E50'>3. How do we share, transfer, and
publicly disclose your personal information</span></p>

    <p style='text-align:justify'><span lang=EN-US style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#2C3E50'>4. How do we protect your
personal information</span></p>

    <p style='text-align:justify'><span lang=EN-US style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#2C3E50'>5. Your rights</span></p>

    <p style='text-align:justify'><span lang=EN-US style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#2C3E50'>6. How do we deal with the
personal information of minors</span></p>

    <p style='text-align:justify'><span lang=EN-US style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#2C3E50'>(If you are the guardian of a
minor to register on his behalf, please read the terms carefully)</span></p>

    <p style='text-align:justify'><span lang=EN-US style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#2C3E50'>7. How to transfer your personal
information globally</span></p>

    <p style='text-align:justify'><span lang=EN-US style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#2C3E50'>8. This policy may change</span></p>

    <p style='text-align:justify'><span lang=EN-US style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#2C3E50'>9. How to contact us</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>We know
the importance of personal information to you, and will do its best to protect
your personal information safe and reliable. We are committed to maintaining
your trust in us and abide by the following principles to protect your personal
information: principle of consistent rights and responsibilities, principle of
clear purpose, principle of choice and consent, principle of least enough,
principle of ensuring security, principle of subject participation, principle
of openness and transparency, etc.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>Please
note that Wonder GameGame may revise and update this agreement in due course,
and you agree to check the latest version of this agreement at any time. Please
read and understand this &quot;Privacy Policy&quot; carefully before using our
products (or services) to ensure that you are always aware of the latest
version of this &quot;Privacy Policy&quot;.</span></p>

    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US>&nbsp;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><b><span lang=EN-US
                                                              style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>1. How we
collect and use your personal information</span></b></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>Personal
information refers to various information recorded electronically or in other
ways that can identify a specific natural person alone or in combination with
other information or reflect the activities of a specific natural person. WonderGame
Game collects and uses your personal information based on the following
purposes described in this policy. If you need to use your information for more
than the following purposes, Wonder GameGame will separately obtain your
consent in an appropriate way:</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(1)
Provide you with the products and services provided by Wonder GameGame on its
and/or its affiliates' web game platform</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>1.
Register as a user.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>Fill in
the information to complete the account creation. For example: your mobile
phone number, ID card, created user name.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>2.
Provide you with advertisements, information and product information that may
be of interest to you</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>In order
to provide you with more relevant advertisements to replace commonly placed
advertisements, we may collect and use your operation records in Wonder GameGame
and some necessary device information (for example: your unique device
identification code), and your Other information and content details browsed or
requested when using our service, game account transaction information, extract
your browsing, behavior habits and other characteristics, and based on the
characteristic tags, send emails, text messages, or other methods to share with
you the same or similar Labeled user groups send marketing messages to provide
or promote our products and services.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>3.
Payment and settlement.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>In order
to facilitate your comprehensive judgment of your account and transaction
risks, identity verification, detection and prevention of security incidents
when you pay for related orders, we may collect your personal property
information during the transaction (only transaction records, virtual currency,
virtual property information such as transactions and game redemption codes).</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>4.
Security</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>We will
use part of your personal device information for identity verification,
security precautions, fraud detection, archive backup and other purposes. For
example, unique device codes are used for security precautions and user
identification, and personal Internet records are used for security precautions
and fraud monitoring.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>When you
use our customer service, we may save your communication/call records and
content or contact information you leave and other information in order to
contact you or help you solve problems, or record the solutions and results of
related problems.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>5.
Product development and service optimization. For example, in order to repair
system failures and optimize our services, we may need to record and analyze
the information generated when the system fails.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(2) The
scope of application of the privacy policy</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>Except
for certain specific products and services, all our products and services are
applicable to this &quot;Privacy Policy&quot;. These specific products and
services will be subject to specific privacy policies. Specific privacy
policies for certain specific products and services will more specifically
explain how we collect and use your information in such products and services.
If there is any inconsistency between the privacy policy of related specific
products and services and this &quot;Privacy Policy&quot;, the privacy policy
of that specific product and service shall apply.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(3)
Exceptions to the application of this privacy policy</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>Our
services may include or link to social media or other services (including
websites) provided by third parties. E.g:</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>1. You
use the &quot;Share&quot; button to share some content with our service, or you
use a third-party connection service to log in to our service. These functions
may collect your relevant information (including your log information), and may
install cookies on your computer, so as to operate the above functions normally;</span></p>

    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US>&nbsp;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>2. We
provide you with links through advertisements or other methods of our services,
so that you can access third-party services or websites, and the third-party
collects and applies your information.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>Such
third-party social media or other services may be operated by third parties.
Your use of the social media services or other services of such third parties
(including any personal information you provide to such third parties) is
subject to the third party's terms of service and privacy policy (not this &quot;Privacy
Policy&quot;). You need to read its terms carefully. This &quot;Privacy
Policy&quot; only applies to the information we collect, and does not apply to
any third party services or third party information usage rules. We are not
responsible for any third party's use of the information provided by you.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(4)
Examples of scenarios where the application client obtains privacy on a mobile
device</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>When we
provide services to you through a mobile client application, we need to obtain
your specific personal information or obtain some specific permissions of the
mobile device in a specific application scenario, for which we will obtain your
consent in advance. The following are some examples of application scenarios:</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>1. In
order to achieve &quot;one-key registration of mobile phone number&quot; or
similar convenient registration functions, call the SMS sending and reading
function of the mobile device, or call the device code reading permission to
obtain IMEI, assign tourist accounts, and use the SMS sending function If any
expenses will be incurred at the time, we will prompt and explain in advance;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>2. In
order for our customer service to better answer and process your customer
complaints in the app, call the camera function permission of the mobile
device, take a photo and upload it for processing;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>3. In
order to implement voice social functions in the app, call one or more of the
volume adjustment permission, microphone permission, recording audio
permission, or Bluetooth pairing permission of the mobile device;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>4. In
order to update and iterate the application itself, call the permission to
install other applications in the application to achieve the purpose of
downloading and updating;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>5. After
the application reports an error or crashes, we need to obtain the permission
to read the system log file in order to obtain the error information for
analysis, better optimize the game logic, and bring a better user experience;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>6. The
application needs to cache and read the resources necessary when it is running.
For this we need to obtain the permission to read and write storage device
information.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>The above
only lists some application scenarios for obtaining mobile device permissions.
When other permissions are invoked, we will comply with the principles of this
privacy policy and local laws and regulations to fully protect your legal
rights and interests such as the right to know.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><b><span lang=EN-US
                                                              style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>2. How do
we use cookies and similar technologies</span></b></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(1)
Cookie</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>Cookies
usually contain identifiers, site names, and some numbers and characters. To
ensure the normal operation of the website and to help us identify you as our
registered user, we will store small data files called cookies on your computer
or mobile device. We will not use cookies for any purpose other than those
described in this policy. You can set, manage or delete cookies through your
browser or other methods according to your preferences.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(2) Do
Not Track</span></p>

    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US>&nbsp;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>Many web
browsers have a Do Not Track function, which can post Do Not Track requests to
websites. Currently, major Internet standards organizations have not
established relevant policies to regulate how websites should respond to such
requests. But if Do Not Track is enabled in your browser, all our websites will
respect your choice. But please note that this may affect your experience of
using Wonder GameGame to provide products and services.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><b><span lang=EN-US
                                                              style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>3. How do
we share, transfer, and publicly disclose your personal information</span></b></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(1)
Sharing</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>You
understand and agree that we will ensure that the data recipient cannot
re-identify the subject of personal information and provide it to a third party
through sharing. We may share your personal information with any companies,
organizations and individuals other than Wonder GameGame under the following
circumstances:</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>1.
Sharing with explicit consent: After obtaining your explicit consent, we will
share your personal information with other parties.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>2. We may
share your personal information with external parties in accordance with laws
and regulations, or mandatory requirements of government authorities.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>3.
Sharing with our affiliated companies: Your personal information may be shared
with affiliated companies of Wonder GameGame. We will only share necessary
personal information and are bound by the purpose stated in this privacy
policy. If the affiliated company wants to change the purpose of processing
personal information, it will again seek your authorization and consent.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>4. Sharing
with authorized partners: Only to achieve the purpose stated in this policy,
some of our services will be provided by authorized partners. We may share some
of your personal information with our partners to provide better customer
service and user experience. We will </span></p>

    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US>&nbsp;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>only
share your personal information for legal, legitimate, necessary, specific and
clear purposes, and will only share personal information necessary to provide
services. Our partners have no right to use the shared personal information for
any other purpose.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>Currently,
our authorized partners include the following two types:</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>1)
Authorized partners for advertising and analysis services. Unless you have your
permission, we will not use your personally identifiable information (referring
to information that is sufficient to identify you, such as your name or email
address, through which you can be contacted or identified) with the provision
of advertising and analysis services of partners to share.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>2)
Suppliers, service providers and other partners. We send information to
vendors, service providers, and other partners that support our business, such
as communication service providers who push notifications on our behalf. These
supports include providing technical infrastructure services, analyzing how our
services are used, measuring the effectiveness of advertisements and services,
providing customer service, payment convenience, and other support for Wonder
GameGame products and services.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(2)
Transfer</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>We will
not transfer your personal information to any company, organization or
individual, except in the following cases:</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>1.
Transfer with explicit consent: After obtaining your explicit consent, we will
transfer your personal information to other parties;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>2. When
it involves a merger, acquisition or bankruptcy liquidation, if it involves the
transfer of personal information, we will inform you of the relevant situation
through push notifications, announcements or other methods, and continue to
protect or require new managers in accordance with the standards required by
laws and regulations Continue to protect your personal information in
accordance with this policy.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(3)
Public disclosure</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>We will
only publicly disclose your personal information under the following
circumstances:</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>1. After
obtaining your explicit consent;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>2.
Related to national security and national defense security;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>3.
Related to public safety, public health, and major public interests;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>4.
Related to criminal investigation, prosecution, trial, and execution of
judgments;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>5. In
order to protect the life, property and other major legal rights of the
information subject or other individuals, but it is difficult to obtain your
own consent;</span></p>

    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US>&nbsp;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>6. The
collected information is disclosed to the public by yourself;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>7.
Collect information from legally publicly disclosed information, such as legal
news reports, government information disclosure and other channels;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>8.
Necessary for signing a contract according to your requirements;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>9.
Necessary for maintaining the safe and stable operation of Wonder GameGame
services, such as discovering and disposing of product or service failures;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>10.
Necessary for legal news reports;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>11. When
it is necessary for academic research institutions to conduct statistical or
academic research based on the public interest, and when they provide academic
research or described results to the outside, they de-identify the information
contained in the results;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>12. Other
circumstances stipulated by laws and regulations.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><b><span lang=EN-US
                                                              style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>4. How do
we protect your personal information</span></b></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(1) We
will take reasonable and feasible measures to protect your personal
information. For example, we use SSL/hash to encrypt and protect your data.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>We have a
dedicated security team responsible for handling data protection related
matters. At the same time, we have also set up specific processes and security
procedures for specific user data collection and processing procedures to
ensure that the storage and use of data meet our expectations and the
requirements of laws and regulations. For example, we use TLS/SSL encryption
technology for data transmission, and SHA256/AES encryption algorithm for
stored sensitive data to ensure its security. In addition, we will regularly
conduct risk assessments on security policies and data protection measures to
ensure that our products will not be threatened by risks such as data leakage
or infringement of privacy.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(2) Other
security measures we take to protect information</span></p>

    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US>&nbsp;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>We manage
the storage and use of standardized information by establishing a data
classification and grading system, data security management specifications, and
data security development specifications.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>We use
information contact confidentiality agreements, monitoring and auditing
mechanisms to fully control data security.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(3) We
only allow Wonder GameGame employees who need to know this information to
access your information, and at the same time require all personnel who may
have access to your information to perform the corresponding confidentiality
obligations. If you fail to fulfill these obligations, you may be held
accountable or the cooperation relationship with Wonder GameGame may be
suspended.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(4) We
will take all reasonable and feasible measures to ensure that irrelevant personal
information is not collected. We will only retain your personal information for
a reasonable period of time, unless it is necessary to extend the retention
period or is permitted by law.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(5) The
Internet is not an absolutely secure environment, and email, instant messaging,
and communication with other Wonder GameGame users are not encrypted. We
strongly recommend that you do not send personal information through such
methods. Please use a complex password to help us ensure the security of your
account.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(6) The
Internet environment is not 100% secure. We will try our best to ensure or
guarantee the security of any information you send to us. If our physical,
technical, or management protection facilities are damaged, resulting in
unauthorized access, public disclosure, tampering, or destruction of
information, resulting in damage to your legitimate rights and interests, we
will bear the corresponding legal responsibility.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(7) In
the unfortunate event of a personal information security incident, we will take
necessary measures to prevent the expansion of the security incident and notify
you in the form of push notifications, announcements, etc.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><b><span lang=EN-US
                                                              style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>5. Your
rights</span></b></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>In
accordance with relevant Chinese laws, regulations, and standards, as well as
common practices in other countries and regions, we guarantee that you exercise
the following rights with respect to your personal information:</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(1)
Access your personal information</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>You have
the right to access your personal information, except for exceptions provided by
laws and regulations.</span></p>

    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US>&nbsp;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(2)
Control your personal information</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>You can
inquire and manage your personal information under your account. Wonder GameGameaccount
name and ID number are your important network identification. For security and
identification considerations, they cannot be changed after registration.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(3)
Delete your personal information</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>We will
collect and use your information only to realize the functions of our products
or services in accordance with this policy. If you find that we have collected
and used your personal information in violation of laws, administrative
regulations, or agreed upon by both parties, you can ask us to delete it. If
you find that your personal information we have collected and stored is wrong,
you can also ask us to correct it. Please contact us through the contact
information listed in this policy.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>(4)
Responding to your above request</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>To ensure
safety, you may need to provide a written request or prove your identity in
other ways. We may ask you to verify your identity before processing your
request. We will respond within a reasonable time limit. If you are not
satisfied, you can contact Wonder GameGame customer service or deal with it in
accordance with the method agreed in the &quot;User Registration Service
Agreement&quot;.</span></p>

    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US>&nbsp;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>For your
reasonable request, we do not charge fees in principle, but for repeated
requests that exceed reasonable limits, we will charge a certain cost depending
on the circumstances. For those that are unreasonably repeated, require too
many technical means (for example, the need to develop new systems or
fundamentally change existing practices), bring risks to the legitimate rights
and interests of others, or are very impractical (for example, involving
information stored on backup tapes) Request, we may refuse.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>In the
following situations, we will not be able to respond to your request in
accordance with the requirements of laws and regulations:</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>1.
Directly related to national security and national defense security;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>2. It is
directly related to public safety, public health, and major public interests;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>3. It is
directly related to criminal investigation, prosecution, trial and judgment
execution;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>4. There
is sufficient evidence to show that you have subjective malice or abuse of
rights;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>5.
Responding to your request will cause serious damage to the legitimate rights
and interests of you or other individuals or organizations;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>6.
Involving commercial secrets;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>7. Other
situations where we have reasonable grounds to refuse.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><b><span lang=EN-US
                                                              style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>6. How do
we deal with the personal information of minors</span></b></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>Our
products, websites and services are mainly for adults. Wonder GameGame complies
with national policies. Minors are not allowed to create their own user
accounts without the consent of their parents or guardians.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US><a
        href="https://creativecommons.org/licenses/by-sa/3.0/"><span style='font-size:
10.5pt;font-family:"Arial",sans-serif;color:#1155CC'>https://creativecommons.org/licenses/by-sa/3.0/</span></a></span></p>

    <p style='text-align:justify;text-indent:20.0pt'><b><span lang=EN-US
                                                              style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>7. How to
transfer your personal information globally</span></b></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>Our
products, websites and services are only for users in mainland China. The
personal information we collect and generate within the territory of the
People's Republic of China will be stored in the territory of the People's Republic
of China, and will not transfer or transfer users' personal information
globally.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><b><span lang=EN-US
                                                              style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>8. This
policy may change</span></b></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>Without
your explicit consent, we will not reduce your rights in accordance with this
privacy policy. We will post any changes to this policy on this page.</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>For major
changes, we will also provide a more significant notice. If you disagree with
the changed content, you can choose to stop using our services; if you continue
to use our services, you agree to receive the revised version of the &quot; &quot;Privacy
Policy&quot;.</span></p>

    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US>&nbsp;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><b><span lang=EN-US
                                                              style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>9. How to
contact us</span></b></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US
                                                           style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#2C3E50'>If you
have any questions, comments or suggestions about this privacy policy, you can
contact us at yongwangkeji@gmail.com. If you are not satisfied with our
response, especially our personal information processing behavior has harmed
your legitimate rights and interests, you can also handle it in accordance with
the &quot;User Service Agreement&quot;.</span></p>

    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US>&nbsp;</span></p>

    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US>&nbsp;</span></p>

    <p style='text-align:justify;text-indent:20.0pt'><span lang=EN-US>&nbsp;</span></p>

    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US>&nbsp;</span></p>

    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US>&nbsp;</span></p>

    <p class=MsoNormal><span lang=EN-US>&nbsp;</span></p>

  </div>






</template>

<style scoped>
h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
  margin: 0;
}

body {
  padding: 20px 20px 20px 20px;
  text-align: left;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;

}

h1 {
  text-align: center;
  font-size: 32px;
  line-height: 48px;
}

h2 {
  font-weight: bold;
  font-size: 28px;
}

b {
  font-weight: bold;
}

.web-body {
  width: 100vw;
  overflow-x: auto;
}

table {
  text-align: left;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  /*font-size: 1.2rem;*/
  /*line-height: 2.2rem;;*/
  border: 1px solid #909399;
  border-collapse: collapse;
}

tr th {
  font-weight: bold;
  background-color: #F7F8FA;
  /*padding: 6px;*/
}

tr td {
  padding: 6px;
}

a {
  color: #0000ff;
}

a2 {
  display: block;
  width: 160px;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/privacy/cn.vue